'use strict';
// import './style.css';

export class SoutMenu
{
    constructor(options = [])
    {
        this.options = options;
        this.init();
    }

    init()
    {
        const instance = this

        const linksColl = document.querySelectorAll('.js-section-link')
        if (linksColl) {
            linksColl.forEach((link) => link.addEventListener('click', function (e) {
                instance.links(e)
            }))
        }
    
    }

    links(e) {
        const instance = this
        e.preventDefault()   
        let elemsList = document.querySelector('.ajax-container');
        let link = e.target.getAttribute('href')
        let sectionCode = e.target.getAttribute('data-section-code')
        let url = link + '?section_code=' + sectionCode + '&AJAX_REQUEST=Y'
        if (!!elemsList) {
            fetch(url, {mode: 'cors'})
            .then(
                function(response) {
                    if (response.status !== 200) {
                        console.log('Looks like there was a problem. Status Code: ' +
                            response.status);
                        return;
                    }
                    response.text().then(function(data) {
                        document.querySelectorAll('.js-section-link').forEach((otherLink) => otherLink.classList.remove('is-active'))
                        e.target.classList.add('is-active')
                        history.pushState({param: 'href'}, '', link)

                        elemsList.innerHTML = data

                    });
                }
            )
            .catch(function(err) {
                console.log('Fetch Error :-S', err);
            });
        }
    }


}